import { render, staticRenderFns } from "./onlineTrainingDetail.vue?vue&type=template&id=f244ed18&scoped=true&"
import script from "./onlineTrainingDetail.vue?vue&type=script&lang=js&"
export * from "./onlineTrainingDetail.vue?vue&type=script&lang=js&"
import style0 from "./onlineTrainingDetail.vue?vue&type=style&index=0&id=f244ed18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f244ed18",
  null
  
)

export default component.exports